import { GetServerSideProps } from 'next';
import { Fragment } from 'react';
import Cookie from 'cookie';

import { wrapper } from 'src/redux/store/store';
import { getSimplePage } from 'src/api/pageApi';
import {
  LastInteractedPsychicCookie,
  PageSetUpInStorageConfig,
  ServerSideRenderingContext,
} from 'types/objectTypes';
import { CustomerType } from 'constants/enums';
import { setUpPageInStore } from 'lib/page.service';
import { fileExtension } from 'lib/regexp.service';
import withMiddleware, { commonMiddleware, postCommonMiddleware } from 'src/shared/lib/middleware/combiner';
import { setDefaultCacheBehavior } from 'lib/storage.service';
import { calculateCustomerType } from 'lib/session.service';
import { Page } from 'src/__generated__/graphqlTypes';
import { getNcOffers } from 'src/api/customerApi';
import { LAST_INTERACTED_PSYCHIC } from 'constants/constants';
import { setPageData } from 'app-redux/actions/pageActions';
import { extractNcOffer, normalizeNcOffer } from 'src/shared/lib/offers';

const handler = async ({
  // @ts-ignore
  req,
  res,
  store,
  query,
  params,
  preview = false,
}: ServerSideRenderingContext): Promise<any> => {
  try {
    const session = req?.session?.getSession();
    const { slug: parametersSlug } = params || { slug: '' };
    const extIdParam = Object.entries(query).find(([key]) => key.toLowerCase() === 'extid')?.[1];
    const customerType = calculateCustomerType(req.session);
    const isAuthorized = customerType === CustomerType.EC;

    if (!session?.isLeadCustomer && isAuthorized) {
      return {
        redirect: {
          permanent: false,
          destination: '/echomepage',
        },
      };
    }

    const slug = (Array.isArray(parametersSlug))
      ? parametersSlug.join('')
      : parametersSlug as string;

    if (!slug || slug.match(fileExtension)) {
      return { notFound: true };
    }

    const promoCode = extractNcOffer(req.cookies, req.query);
    let page: Page | undefined;
    let offers: any;

    if (promoCode) {
      [page, offers] = await Promise.all([
        getSimplePage({ preview, slug, customerType }),
        getNcOffers(promoCode),
      ]);
    } else {
      page = await getSimplePage({ preview, slug, customerType });
    }

    if (!page) {
      return {
        redirect: {
          permanent: false,
          destination: (customerType === CustomerType.NC)
            ? '/'
            : '/echomepage',
        },
      };
    }

    if (offers) {
      try {
      // eslint-disable-next-line max-len
        const lastInteractedPsychicString = req.cookies[LAST_INTERACTED_PSYCHIC] as any as string | undefined;
        let lastInteractedPsychic: LastInteractedPsychicCookie | undefined;

        if (lastInteractedPsychicString) {
        // eslint-disable-next-line max-len
          lastInteractedPsychic = JSON.parse(lastInteractedPsychicString) as LastInteractedPsychicCookie;
        }

        if (lastInteractedPsychic?.promoCode?.toLowerCase() === promoCode?.toLowerCase()
            && lastInteractedPsychic?.id === Number(extIdParam)) {
          const normalizedOffer = normalizeNcOffer(offers, lastInteractedPsychic);
          store.dispatch(setPageData({ offer: normalizedOffer }));
        } else if (lastInteractedPsychic) {
          res.setHeader('Set-Cookie', Cookie.serialize(LAST_INTERACTED_PSYCHIC, '', { path: '/', maxAge: 0 }));
        }
      } catch (e) {
        console.error(e);
      }
    }

    const pageSetUpConfig: PageSetUpInStorageConfig = {
      page,
      session,
      slug,
      store,
      headers: req.headers,
      isAuthorized,
    };
    setUpPageInStore(pageSetUpConfig);
    setDefaultCacheBehavior(120, res);

    return { props: {} };
  } catch (e) {
    console.error(e);

    return { props: {} };
  }
};

export const getServerSideProps: GetServerSideProps = wrapper
// @ts-ignore
  .getServerSideProps(withMiddleware(
    handler,
    { prior: commonMiddleware, post: postCommonMiddleware },
  ));

export default Fragment;
